module.exports = __webpack_public_path__ + "img/no-file.2696b2aa.png";